/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon20Regular = forwardRef('ArrowUiCornerOutUpRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 3.75A2.25 2.25 0 0 0 3.75 6v8A2.25 2.25 0 0 0 6 16.25h8A2.25 2.25 0 0 0 16.25 14v-2a.75.75 0 0 1 1.5 0v2A3.75 3.75 0 0 1 14 17.75H6A3.75 3.75 0 0 1 2.25 14V6A3.75 3.75 0 0 1 6 2.25h2a.75.75 0 0 1 0 1.5H6Z" }),
        React.createElement("path", { d: "M16.25 4.81V8a.75.75 0 0 0 1.5 0V3.5c0-.69-.56-1.25-1.25-1.25H12a.75.75 0 0 0 0 1.5h3.19L9.47 9.47a.75.75 0 1 0 1.06 1.06l5.72-5.72Z" })));
});
